import fastpokLogo from "../../assets/poktools/fastpok.png";
import trainerLogo from "../../assets/poktools/trainer.png";
import rpLogo from "../../assets/poktools/rp.png";

const poktoolsLogos = {
  trainer: trainerLogo,
  fastpok: fastpokLogo,
  rp: rpLogo
};

const POKTOOLS_API_URL = "https://test.poktools.com/api/";
const POSITIONS = ["SB", "BU", "CO", "HJ", "LJ", "MP", "UTG2", "UTG1", "UTG"];
const FULL_POSITIONS = [
  "BB",
  "SB",
  "BU",
  "CO",
  "HJ",
  "LJ",
  "MP",
  "UTG2",
  "UTG1",
  "UTG"
];

const reorderPositions = (positions) => {
  let reordered = [];
  for (let k = POSITIONS.length - 1; k >= 0; k--) {
    let origin = POSITIONS[k];
    for (let pos of positions) {
      if (pos === origin) {
        reordered.push(pos);
      }
    }
  }
  return reordered.join(",");
};

export {
  poktoolsLogos,
  POKTOOLS_API_URL,
  FULL_POSITIONS,
  POSITIONS,
  reorderPositions
};
